import React, { Component } from 'react';
import { Row, Col, Clearfix, Button } from 'react-bootstrap';
import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import Icon from '../../../../components/Icon';
import { handleFieldChange } from "../../../../Utils";
import SelectWrap from "../../../../components/SelectWrap";
import countries from "../../../../data/countries";
import languages from "../../../../data/languages";

const countriesObj = { all: 'All', ...countries };

class Form extends Component {
    constructor(props) {
        super(props);

        if(props.offer) this.state = this.getOfferData(props.offer);
        else {
            this.state = {
                source: '',
                country: null,
                language: null,
                title: '',
                body: '',
                icon: '',
                image: '',
                url: '',
                cpc: '',
                closeUrl: '',
                closeCpc: '',
                blockUrl: '',
                blockCpc: '',
                device: 'all',
            }
        }


        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    getOfferData(offer) {
        const params = [ 'id', 'source', 'device', 'country', 'language', 'title', 'body', 'icon', 'image', 'url', 'cpc', 'closeUrl', 'closeCpc', 'blockUrl', 'blockCpc' ];

        return params.reduce((obj, param) => {
            if(offer[param]) obj[param] = offer[param];
            else obj[param] = '';

            return obj;
        }, {});
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.onSubmit(this.state);
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit}>
                    <SelectWrap
                        values={{ mobile: 'Mobile', desktop: 'Desktop', all: 'All' }}
                        label="Device:"
                        name="device"
                        onChange={this.handleFieldChange}
                        value={this.state.device}
                        required
                    />
                    <SelectWrap
                        values={countriesObj}
                        label="Country:"
                        name="country"
                        onChange={this.handleFieldChange}
                        value={this.state.country}
                        multi
                        required
                    />
                    <SelectWrap
                        values={languages}
                        label="Language:"
                        name="language"
                        onChange={this.handleFieldChange}
                        value={this.state.language}
                        multi
                    />
                    <SelectWrap
                        values={['MANUAL_APP_VPN_PUSH', 'MANUAL_SERP_DATING_PUSH', 'MANUAL_SERP_FINANCE_PUSH', 'MANUAL_SERP_DATING_ALLOW', 'MANUAL_APP_VPN_ALLOW', 'MANUAL_SERP_DATING_CLIENT', 'MANUAL_SSP_METACPA', 'MANUAL_HT_PUSH', 'MANUAL_SERP_BING', 'MANUAL_SERP_GOOGLE', 'MANUAL_SSP_PRIMEROLL', 'MANUAL_FLUENT_PUSH' ]}
                        label="Source:"
                        name="source"
                        onChange={this.handleFieldChange}
                        value={this.state.source}
                        required
                    />
                    <FieldGroup
                        name="title"
                        label="Title:"
                        onChange={this.handleFieldChange}
                        value={this.state.title}
                        required
                    />
                    <FieldGroup
                        name="body"
                        label="Body:"
                        onChange={this.handleFieldChange}
                        value={this.state.body}
                        required
                    />
                    <FieldGroup
                        name="icon"
                        label="Icon:"
                        onChange={this.handleFieldChange}
                        value={this.state.icon}
                        required
                    />
                    <FieldGroup
                        name="image"
                        label="Image:"
                        onChange={this.handleFieldChange}
                        value={this.state.image}
                    />
                    <FieldGroup
                        name="url"
                        label="URL:"
                        onChange={this.handleFieldChange}
                        value={this.state.url}
                        required
                    />
                    <FieldGroup
                        type="number"
                        name="cpc"
                        label="Cpc:"
                        onChange={this.handleFieldChange}
                        value={this.state.cpc}
                        step={0.001}
                        required
                    />
                    <Clearfix>
                        <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/>Save</Button>
                    </Clearfix>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/scenes/BidderManualOffers/components/Form/index.js